import PropTypes from 'prop-types';

import { OverlayTriggerTooltip, Pill } from '@utilities';

const SubscribedFilterFooter = ({ answers }) => {
  if (!answers?.length) return null;

  const firstAnswerName = answers[0].name;
  const hasMultipleSubscriptions = answers.length > 1;

  const value = hasMultipleSubscriptions
    ? `${firstAnswerName} or ${answers.length - 1} more`
    : firstAnswerName;

  const tooltip = hasMultipleSubscriptions ? (
    <>
      {answers.map((selection) => (
        <div key={selection.id ?? selection.name}>
          <small>{selection.name}</small>
        </div>
      ))}
    </>
  ) : null;

  return (
    <div>
      This card is limited to Subscribed Categories:{' '}
      <OverlayTriggerTooltip content={tooltip}>
        <Pill value={value} />
      </OverlayTriggerTooltip>
    </div>
  );
};

SubscribedFilterFooter.propTypes = {
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default SubscribedFilterFooter;
